module.exports = __webpack_public_path__ + "images/icons/flags/CZ-1ea12a93.svg";